import React from "react";
import axios from "axios";
import _ from "lodash";

import {
    PAGE_DATA_PENDING,
    PAGE_DATA_FULFILLED,
    PAGE_DATA_REJECTED,
    PAGE_ADD_PAGE,
    PAGE_LAYOUT_CONFIGURATION,
    PAGE_COMPONENT_CONFIGURATION,
    PAGE_SELECTED_TABS,
    PAGE_SAVE_DATA_PENDING,
    PAGE_SAVE_DATA_FULFILLED,
    PAGE_SAVE_DATA_REJECTED
} from "./pageTypes";

import { uuid } from "../../utilities/GeneralUtilities";
import { axiosDelay } from "../../config/config";


export const findXGridComponent = (id, config) => {
	// console.log(id);
	// console.log(config);

	// Check if root xGrid
	if (config.type.toLowerCase() === "xgrid") {
		if (config.id === id) {
			return config;
		} else {
			for (let c of config.configuration.components) {
				const foundLayout = findXGridComponent(id, c);
				if (foundLayout) {
					return foundLayout;
				}
			}
		}
	} else if (config.type.toLowerCase() === 'tab') {
		for (let t of config.configuration.components) {
			const foundLayout = findXGridComponent(id, t);
			if (foundLayout) {
				return foundLayout;
			}
		}
	} else if (config.type.toLowerCase() === 'tabfilter') {
		for (let t of config.configuration.components) {
			const foundLayout = findXGridComponent(id, t);
			if (foundLayout) {
				return foundLayout;
			}
		}
	} else if (config.type.toLowerCase() === 'grid') {
		for (let t of config.configuration.components) {
			const foundLayout = findXGridComponent(id, t);
			if (foundLayout) {
				return foundLayout;
			}
		}
	} else if (config.type.toLowerCase() === 'card') {
		for (let t of config.configuration.components) {
			const foundLayout = findXGridComponent(id, t);
			if (foundLayout) {
				return foundLayout;
			}
		}
	} else if (config.type.toLowerCase() === 'navigation') {
		// check navigation.details
		let t = config.configuration.details;
		const foundLayout = findXGridComponent(id, t);
		if (foundLayout) {
			return foundLayout;
		} else {
			// check navigation.selector
			let t = config.configuration.selector;
			const foundLayout = findXGridComponent(id, t);
			if (foundLayout) {
				return foundLayout;
			}
		}
	} else if (config.type.toLowerCase() === 'navigationcards') {
		let t = config.configuration.element.summary
		const foundLayout = findXGridComponent(id, t);
		if (foundLayout) {
			return foundLayout;
		}
	}
}

export const findComponent = (xId, xIdHint, components) => {
	// console.log(xId);
	// console.log(xIdHint);
	// console.log(components);

	let id = xId;

	// xIdHint is used exclusively for Flip Components, which are nested in a component wrapper.
	// xIdHint is undefined when a null is passed from page.componentEdit.xIdHint and null when explicitly passing a null
	// {} --> wrapper.flip.component
	if ((xIdHint !== undefined) && (xIdHint !== null)) {
		id = xIdHint;
	}


	for (let c of components) {
		if (c.id === id) {
			if ((xIdHint !== undefined) && (xIdHint !== null)) {
				return c.wrapper.flip.component
			} else {
				return c
			}
		} else if (c.type.toLowerCase() === 'xgrid') {
			for (let t of c.configuration.components) {
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'tab') {
			for (let t of c.configuration.components) {
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'tabfilter') {
			for (let t of c.configuration.components) {
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'grid') {
			for (let t of c.configuration.components) {
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'card') {
			for (let t of c.configuration.components) {
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'navigation') {
			// check navigation.details
			let t = c.configuration.details;
			const foundComponent = findComponent(id, xIdHint, [t]);
			// console.log(foundComponent);
			if (foundComponent) {
				return foundComponent;
			} else {
				// check navigation.selector
				let t = c.configuration.selector;
				const foundComponent = findComponent(id, xIdHint, [t]);
				// console.log(foundComponent);
				if (foundComponent) {
					return foundComponent;
				}
			}
		} else if (c.type.toLowerCase() === 'navigationcards') {
			let t = c.configuration.element.summary
			const foundComponent = findComponent(id, xIdHint, [t]);
			// console.log(foundComponent);
			if (foundComponent) {
				return foundComponent;
			}
		}

	}

}

export function pageLoadFromDBAction() {
    return (dispatch, getState) => {
        const state = getState();
        const config = state.config.data;

        console.log('pageLoadFromDBAction');

        dispatch({
            type: PAGE_DATA_PENDING,
            payload: null
        });

        setTimeout(function () {

            // Here we pass a date time stamp to ensure the latest config is always loaded
            axios
                .get(config.authentication.api + 'pages?db={0}'.format(config.authentication.apiSource))
                .then(function (response) {

                    const pages = JSON.parse(response.data.pages);

                    if (pages) {
                        // Store the configuration
                        dispatch({type: PAGE_DATA_FULFILLED, payload: pages});
                    } else {
                        dispatch({type: PAGE_DATA_REJECTED, payload: 'User page layout does not exist.'});
                        dispatch(pageLoadFromConfigAction());
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    dispatch({type: PAGE_DATA_REJECTED, payload: error});
                });
        }, axiosDelay);

    }
}

export function pageLoadFromConfigAction() {
    return (dispatch, getState) => {
        const state = getState();

        const configPages = state.config.data.pages;

        console.log('pageLoadFromConfigAction');

        dispatch({
            type: PAGE_DATA_PENDING,
            payload: null
        });

        if (configPages) {
            // Store the configuration
            dispatch({type: PAGE_DATA_FULFILLED, payload: configPages});
        } else {
            dispatch({type: PAGE_DATA_REJECTED, payload: 'Pages from configuration does not exist.'});
        }

    }
}

export function pageSaveToDBAction(id, action, pages) {
    return (dispatch, getState) => {
        const state = getState();

        const config = state.config.data;
        const email = state.user.email;

        // console.log('pageSaveToDBAction');

        dispatch({
            type: PAGE_SAVE_DATA_PENDING,
            payload: null
        });

        setTimeout(function () {
            // console.log(pages);
            const postBody = {
                // ID: 1,
                Email: email,
                Pages: JSON.stringify(pages)
            }

            // Here we pass a date time stamp to ensure the latest config is always loaded
            axios.post(config.authentication.api + 'pages/savelayout?db={0}'.format(config.authentication.apiSource), postBody)
                .then(function (response) {
                    dispatch({type: PAGE_SAVE_DATA_FULFILLED, payload: pages});
					dispatch({type: PAGE_LAYOUT_CONFIGURATION, payload: {action: action, id: id}});
                })
                .catch(function (error) {
                    dispatch({type: PAGE_SAVE_DATA_REJECTED, payload: error});
                });
        }, axiosDelay);

    }
}

export function pageAddPageAction(id, title, route, icon, embedded, components) {
    return (dispatch, getState) => {
        const state = getState();
        const pages = _.cloneDeep(state.page.page);

        // console.log('pageActions:pageAddPageAction', id);

        let defaultComponents = components;
        let defaultTab = null;

        if (!defaultComponents)
            defaultComponents = [];

        if (defaultComponents.length === 0) {
            defaultTab = uuid();
            defaultComponents.push({
                id: defaultTab,
                type: "Tab",
                config: {
                    tabs: []
                }
            });
        }

        const page = {
            id: id,
            title: title,
            route: route,
            icon: icon,
            embedded: embedded ? embedded : false,
            components: defaultComponents
        }

        pages.push(page);

        dispatch({ type: PAGE_ADD_PAGE, payload: pages });

        setTimeout(() => {
            if (defaultTab) {
                dispatch(pageTabAddAction(page.id, defaultTab, "Default", true));
            }
        }, 0);


    }
}

export function pageTabSelectedAction(page, id, tab) {
    return (dispatch, getState) => {
        const state = getState();

        const allSelectedTabs = state.page.selectedTabs;

        const tabInfo = allSelectedTabs.find(p => p.key === '{0}-{1}'.format(page, id));

        if (tabInfo) {
            tabInfo.value = tab;
        } else {
            allSelectedTabs.push({
                key: '{0}-{1}'.format(page, id),
                value: tab
            })
        }

        dispatch({
            type: PAGE_SELECTED_TABS,
            payload: allSelectedTabs
        });

    }
}

export function pageTabRenamedAction(page, id, tab, name) {
    return (dispatch, getState) => {
        const state = getState();

        const components = state.page.page.find(p => p.id === page).components;

        const findResult = findComponent(id, null, components);

        if (findResult) {

            const tabToRename = findResult.component.config.tabs.find(t => t.id === tab);
            tabToRename.name = name;

            // Notify the component of the change
            dispatch({
                type: PAGE_COMPONENT_CONFIGURATION,
                payload: { id: id, action: '', type: findResult.component.type, config: findResult.component.config }
            });
        }

    }
}

export function pageTabAddAction(page, id, name, withLayout) {
    return (dispatch, getState) => {
        const state = getState();

        const components = state.page.page.find(p => p.id === page).components;

		const findResult = findComponent(id, null, components);

        // console.log('pageTabAddAction:findResult()', findResult);

        if (findResult) {
            const newTab = {
                id: uuid(),
                name: name,
                components: []
            }

            // TODO: Implement layout options
            newTab.components.push({
                id: uuid(),
                type: "Layout",
                config: {
                    layouts: {
                        lg: [],
                        md: [],
                        sm: [],
                        xs: [],
                        xxs: []
                    },
                    components: {}
                }
            })

            findResult.component.config.tabs.push(newTab);

            // Notify the component of the change
            dispatch({
                type: PAGE_COMPONENT_CONFIGURATION,
                payload: { id: id, action: '', type: findResult.component.type, config: findResult.component.config }
            });
        }


    }
}

export function pageTabDeleteAction(page, id, tab) {
    return (dispatch, getState) => {
        const state = getState();

        const components = state.page.page.find(p => p.id === page).components;

		const findResult = findComponent(id, null, components);

        if (findResult) {
            const tabIndex = findResult.component.config.tabs.findIndex(t => t.id === tab);
            if (tabIndex >= 0) {
                findResult.component.config.tabs.splice(tabIndex,1);

                // Notify the component of the change
                dispatch({
                    type: PAGE_COMPONENT_CONFIGURATION,
                    payload: { id: id, action: '', type: findResult.component.type, config: findResult.component.config }
                });
            }
        }


    }
}

export function pageTabAddComponentAction(page, id, tab, component) {
    return (dispatch, getState) => {
        const state = getState();

        const components = state.page.page.find(p => p.id === page).components;

		const findResult = findComponent(id, null, components);

        if (findResult) {
            const tabToAddTo = findResult.component.config.tabs.find(t => t.id === tab);
            if (tabToAddTo) {
                // Setup id
                component.id = uuid();

                // If our first component is a layout then we add the component to the
                // layout otherwise we add it to the root
                if (tabToAddTo.components.length === 0) {
                    tabToAddTo.components.push(component);

                    // Notify the component of the change
                    dispatch({
                        type: PAGE_COMPONENT_CONFIGURATION,
                        payload: { id: id, action: '', type: findResult.component.type, config: findResult.component.config }
                    });
                } else if (tabToAddTo.components[0].type.toLowerCase() === 'layout') {
                    // Add to the layout
                    const layout = tabToAddTo.components[0];

                    // Inject the layout
                    layout.config.layouts.lg.push({w: 6, h: 2, x: 0, y: Infinity, i: component.id});
                    layout.config.layouts.md.push({w: 6, h: 2, x: 0, y: Infinity, i: component.id});
                    layout.config.layouts.sm.push({w: 6, h: 2, x: 0, y: Infinity, i: component.id});
                    layout.config.layouts.xs.push({w: 6, h: 2, x: 0, y: Infinity, i: component.id});
                    layout.config.layouts.xxs.push({w: 6, h: 2, x: 0, y: Infinity, i: component.id});

                    // Inject the component
                    layout.config.components[component.id] = component;

                    // TODO: Revisit how and when we push a state change to a page
                    // and all it's children
                    // dispatch({
                    //     type: PAGE_LAYOUT_CONFIGURATION,
                    //     payload: id
                    // });

                    // Notify the component of the change
                    dispatch({
                        type: PAGE_COMPONENT_CONFIGURATION,
                        payload: { id: layout.id, action: '', type: 'layout', config: layout.config }
                    });
                }
            }
        }
    }
}

export function pageDeleteComponentAction(page, id) {
    return (dispatch, getState) => {
        const state = getState();
        const components = state.page.page.find(p => p.id === page).components;

        const findResult = findComponent(id, null, components);

        if (findResult) {
            if (findResult.parent.type.toLowerCase() === 'layout') {
                const layout = findResult.parent;

                layout.config.layouts.lg.splice(layout.config.layouts.lg.findIndex(c => c.i === id), 1);
                layout.config.layouts.md.splice(layout.config.layouts.md.findIndex(c => c.i === id), 1);
                layout.config.layouts.sm.splice(layout.config.layouts.sm.findIndex(c => c.i === id), 1);
                layout.config.layouts.xs.splice(layout.config.layouts.xs.findIndex(c => c.i === id), 1);
                layout.config.layouts.xxs.splice(layout.config.layouts.xxs.findIndex(c => c.i === id), 1);

                // Drop the component
                delete layout.config.components[id];

                // Clear settings
                // dispatch(appSetSettingsContentAction({ key: null, location: null, icon: <SettingsIcon />, content: null }));

                // TODO: Revisit how and when we push a state change to a page
                // and all it's children
                dispatch({
                    type: PAGE_LAYOUT_CONFIGURATION,
                    payload: id
                });
            }
        }

    }
}

export function pageLayoutConfigurationAction(pageID, id, layouts) {
    return (dispatch, getState) => {
        const state = getState();

		const pageConfigs = state.config.data.pageConfigs;
        const pages = state.page.pages;
        const valPages = JSON.parse(JSON.stringify(pages));   // Save pages "By Value"
        const activeRole = state.persist.activeRoleName;
        const page = valPages.find(p => p.name === pageID);

		// Each page has 3 potential areas, need to loop through each one to find our xGrid
		// break when found
		for (let i = 0; i < pageConfigs.length; i++ ) {
			const roleConfig = page.roles.find(r => r.name === activeRole)[pageConfigs[i]];
			// console.log(roleConfig);

			if (roleConfig) {
				const xGridComponent = findXGridComponent(id, roleConfig);

				if (xGridComponent) {
					// console.log('pageLayoutConfigurationAction: ', xGridComponent);
					xGridComponent.configuration.layouts = layouts;    // Update the Value valPages

					setTimeout(() => {
					    dispatch(pageSaveToDBAction(id, 'layout', valPages));
					}, 0);

					break;

				} else {
					console.log('**ERROR** Could not find xGridComponent {0}'.format(id));
				}
			}
		}

    }
}

export function pageComponentResizeAction(pageID, id, config) {
    return (dispatch, getState) => {
        const state = getState();

		const xIdHint = state.page.componentEdit.xIdHint;

		const pageConfigs = state.config.data.pageConfigs;
		const pages = state.page.pages;
		const valPages = JSON.parse(JSON.stringify(pages));   // Save pages "By Value"
		const activeRole = state.persist.activeRoleName;
		const page = valPages.find(p => p.name === pageID);

		// Each page has 3 potential areas for Components, need to loop through each one to find ours
		// break when found
		for (let i = 0; i < pageConfigs.length; i++ ) {
			const roleConfig = page.roles.find(r => r.name === activeRole)[pageConfigs[i]];
			// console.log(roleConfig);

			if (roleConfig) {
				// const gridConfig = roleConfig.configuration;
				const findResult = findComponent(id, xIdHint, [roleConfig]);

				if (findResult) {
					// console.log('pageComponentConfigurationAction: ', findResult);
					findResult.configuration = config;	// Update the Value valPages

					dispatch({
						type: PAGE_COMPONENT_CONFIGURATION,
						payload: {id: id, action: 'resize', type: findResult.type, config: config}
					});

					break;

				} else {
					console.log('**ERROR** Could not find component {0}'.format(id));
				}
			}
		}

    }
}

export function pageComponentConfigurationAction(pageID, id, config) {
	return (dispatch, getState) => {
		const state = getState();

		const xIdHint = state.page.componentEdit.xIdHint;

		const pageConfigs = state.config.data.pageConfigs;
		const pages = state.page.pages;
		const valPages = JSON.parse(JSON.stringify(pages));   // Save pages "By Value"
		const activeRole = state.persist.activeRoleName;
		const page = valPages.find(p => p.name === pageID);

		// Each page has 3 potential areas for Components, need to loop through each one to find ours
		// break when found
		for (let i = 0; i < pageConfigs.length; i++ ) {
			const roleConfig = page.roles.find(r => r.name === activeRole)[pageConfigs[i]];
			// console.log(roleConfig);

			if (roleConfig) {
				// const gridConfig = roleConfig.configuration;
				const findResult = findComponent(id, xIdHint, [roleConfig]);

				if (findResult) {
					// console.log('pageComponentConfigurationAction: ', findResult);
					findResult.configuration = config;	// Update the Value valPages

					dispatch({
						type: PAGE_COMPONENT_CONFIGURATION,
						payload: {id: id, action: 'config', type: findResult.type, config: config}
					});

					setTimeout(() => {
						dispatch(pageSaveToDBAction(id, 'config', valPages));
					}, 0);

					break;

				} else {
					console.log('**ERROR** Could not find component {0}'.format(id));
				}
			}
		}

	}
}